<form [formGroup]="userProfileFormGroup">
    <h3 class="text-center">
        {{ "Profile Info" | translate }}
    </h3>
    <h3 class="text-center">
        {{ "Create Profile Welcome Message" | translate }}
    </h3>
    <div class="text-center text-muted mb-4">
        {{ "Create Profile Welcome Description" | translate }}
    </div>

    <div class="d-flex flex-column my-2">
        <!-- First Name Input -->
        <mat-form-field appearance="outline" color="accent">
            <mat-label>First Name</mat-label>
            <input
                matInput
                placeholder="Enter first name…"
                formControlName="firstName"
                maxlength="32"
                required />
            <mat-error>
                {{ getHelperText("firstName") }}
            </mat-error>
        </mat-form-field>
        <!-- Last Name Input -->
        <mat-form-field appearance="outline" color="accent">
            <mat-label>Last Name</mat-label>
            <input
                matInput
                placeholder="Enter last name…"
                formControlName="lastName"
                maxlength="32"
                required />
            <mat-error>
                {{ getHelperText("lastName") }}
            </mat-error>
        </mat-form-field>
        <!-- User Name Input -->
        <mat-form-field appearance="outline" color="accent">
            <mat-label>User Name</mat-label>
            <input
                matInput
                placeholder="Enter user name…"
                formControlName="userName"
                required />
            <mat-error>
                {{ getHelperText("userName") }}
            </mat-error>
        </mat-form-field>
    </div>
    <!-- Contact Info -->
    <h5 class="text-muted font-weight-bold text-center mb-4">Contact Info</h5>
    <address-section
        #addressSection
        (sectionChanged)="addressSectionValueChanges()" />
    <div class="form-check">
        <input
            class="form-check-input"
            type="checkbox"
            id="business-type-check"
            formControlName="businessSelected"
            (change)="checkBusiness($event)" />
        <label class="form-check-label" for="business-type"
            >Register as a Business</label
        >
    </div>
    <div class="form-check">
        <input
            class="form-check-input"
            type="checkbox"
            id="not-for-profit-type-check"
            formControlName="charitySelected"
            (change)="checkCharity($event)" />
        <label class="form-check-label" for="not-for-profit-type-check"
            >Register as a Not for Profit</label
        >
    </div>
    <div class="d-flex">
        <button
            type="button"
            class="btn btn-primary rounded-pill text-light m-auto"
            [disabled]="!isFormValid"
            [ngClass]="
                isFormValid
                    ? 'btn-background-active'
                    : 'btn-background-inactive'
            "
            type="submit"
            (click)="onSubmit()">
            {{ submitButtonLabel }}
        </button>
    </div>
</form>
